import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {TimelineLite} from "gsap";
import {ThorGameMode} from "../../gamemode/ThorGameMode";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";
import {ThorFSThorNearWinView} from "./ThorFSThorNearWinView";

/**
 * Created by Jerker Nord on 2019-07-03.
 */

export class ThorFSThorNearWinController extends BeforeSpinStopPresentationController {

    private _playFSThorNearWin:boolean;
    private _FSThorNearWinView:ThorFSThorNearWinView;

    constructor(index:number) {
        super(index, "ThorFSThorNearWinController");
        this._FSThorNearWinView = ThorGameModuleConfig.thorFSThorNearWinView = new ThorFSThorNearWinView();
    }

    protected parseFeatureTriggered(data:ThorParsedGameData):boolean {
        this._playFSThorNearWin = false;
        if(data.mode == ThorGameMode.FREESPIN) {
            this._playFSThorNearWin = true;
        }
        return this._playFSThorNearWin;
    }

    protected getSpinStopDelay(data:ThorParsedGameData):number {
        return GameSetting.isFastSpin ? 1 : 1.5;
    }

    protected startPresentation(timeline:TimelineLite):void {
        this._FSThorNearWinView.enableNearWin();
    }

    protected stopPresentation(isAborted:boolean):void {
        if(isAborted == true) {
            //Do nothing?
        }
    }

    protected resetFeature() {
        //TODO: Do reset?
    }
}